import React from 'react';
import { makeInput } from '../helpers';

const QuestionBlock = React.memo((props) => {
  return makeInput(props);
});

export default QuestionBlock;
